// service
import AxiosInstanceCreator from 'services/api';

// models
import type { BaseApiResponse } from 'modules';
import type {
  ReqChangeNationMobile,
  ReqSendSms,
  ReqTempPassword,
  ReqVerifyCode,
  VerifyResult
} from '../models/sms.model';

// libraries
import { type AxiosInstance } from 'axios';

// SMS 메시지 발송 및 비밀번호 재설정

// 회원가입: POST /v1/api/sms > GET /v1/api/sms/verify
// 비밀번호 찾기: POST /v1/api/sms/temp-pwd
// (로그인)임시 비밀번호 변경: POST /v1/api/auth/passwd
// 마이페이지 비밀번호 변경: POST /v1/api/auth/passwd
// 마이페이지 휴대폰 번호 변경: POST /v1/api/sms/change/pwd > GET /v1/api/sms/verify

export class SmsAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 인증번호 발송 API */
  async sendSms(params: ReqSendSms): Promise<BaseApiResponse> {
    return await this.Axios.get<BaseApiResponse>('/sms', { params }).then((res) => res.data);
  }

  /** 인증번호 단순 검증 API */
  async verifyCode(params: ReqVerifyCode): Promise<BaseApiResponse<VerifyResult>> {
    return await this.Axios.get<BaseApiResponse<VerifyResult>>('/sms/verify', { params }).then(
      (res) => res.data
    );
  }

  /** 임시 비밀번호 생성 및 발송, 화면 경로: 로그인 메인 > 패스워드 찾기 API */
  async sendTempPwd(params: ReqTempPassword): Promise<BaseApiResponse> {
    return await this.Axios.get<BaseApiResponse>('/sms/temp-pwd', { params }).then(
      (res) => res.data
    );
  }

  /** 회원 가입 또는 모바일+국가 변경을 위한 인증코드 발송 API */
  async sendSmsForChangeNationMobile(params: ReqChangeNationMobile): Promise<BaseApiResponse> {
    return this.Axios.get<BaseApiResponse>('/sms/change/pwd', {
      params
    }).then((res) => res.data);
  }
}
